import { Button, Container } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import TabelaAgendamentosPresenciais from '../../Components/TabelaAgendamentosPresenciais';
import TabelaHorariosDisponiveisPresenciais from '../../Components/TabelaHorariosDisponiveisPresenciais';
import TabelaHorariosIndisponiveisPresenciais from '../../Components/TabelaHorariosIndisponiveisPresenciais';
import TabelaPeriodosIndisponiveisPresenciais from '../../Components/TabelaPeriodosIndisponiveisPresenciais';
import TabelaSessoesPresenciais from '../../Components/TabelaSessoesPresenciais';

// import { Container } from './styles';

const SessoesPresenciais: React.FC = () => {
  return (
    <>
      <Header active='AreaDoMonitor'/>
      <Container style={{backgroundColor:'rgba(255,255,255,0.8)',textAlign:'left', padding:'1rem'}} maxWidth="lg">
        <Link style={{color: 'inherit', textDecoration: 'inherit'}} to='/AreaDoMonitor'>
          <Button variant="contained">
            Voltar
          </Button>
        </Link>
        <div style={{margin:'20px 0px'}}></div>
        <TabelaAgendamentosPresenciais/>
        <div style={{margin:'20px 0px'}}></div>
        <TabelaSessoesPresenciais/>
        <div style={{margin:'20px 0px'}}></div>
        <TabelaHorariosDisponiveisPresenciais/>
        <div style={{margin:'20px 0px'}}></div>
        <TabelaHorariosIndisponiveisPresenciais/>
        <div style={{margin:'20px 0px'}}></div>
        <TabelaPeriodosIndisponiveisPresenciais/>
      </Container>
      <Footer/>
    </>
  );
}

export default SessoesPresenciais;